import { Box, Card, Grid, Typography } from '@mui/material';
import React from 'react';

import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faUserTie } from '@fortawesome/pro-duotone-svg-icons';
import { useTheme } from '@mui/system';
import { OptionType } from '../../atoms';

export type GestionDirigeant = {
    custom_l2d: {
        dateEffetModificationDirigeant: string;
    };
    individu: {
        descriptionPersonne: {
            nom: string;
            prenoms: string;
        };
        typePersonne: string;
    };
    entreprise: {
        denomination: string;
    };
    statutPourLaFormalite: OptionType;
};

export type GestionDirigeantWidgetCallbackArgs = (
    gestionDirigeant: GestionDirigeant,
    index: number,
) => void;

export type GestionDirigeantWidgetType = {
    gestionDirigeant: GestionDirigeant;
    actions?: Array<{
        name: string;
        icon?: React.ReactNode | React.FunctionComponent;
        tooltip?: string;
        text?: string;
        onClick: GestionDirigeantWidgetCallbackArgs;
    }>;
    index?: number;
};

// exemple de style sur DisplayFile

export const GestionDirigeantWidget: React.FunctionComponent<GestionDirigeantWidgetType> =
    function ({ gestionDirigeant, actions, index = -1 }: GestionDirigeantWidgetType) {
        const theme = useTheme();
        return (
            <Card sx={{ padding: '10px', cursor: 'pointer', margin: '15px 0' }}>
                <Grid
                    container
                    sx={{
                        marginLeft: '0px',
                    }}
                >
                    <Grid
                        item
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            paddingLeft: '0px',
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="row"
                            gap="10px"
                            sx={{
                                margin: '0 12px 0',
                            }}
                        >
                            <Box
                                data-testid="test-id-status-color-box"
                                sx={{
                                    margin: '0px',
                                    padding: '10px',
                                    borderRadius: '10px',
                                    fontSize: '25px',
                                    maxHeight: '65px',
                                    backgroundColor: 'rgba(66,221,245,0.2)',
                                }}
                            >
                                <FaOptionIcon
                                    data-testid="test-id-mimetype-icone"
                                    icon={faUserTie}
                                    color={theme.palette.primary.main}
                                    sx={{ fontSize: '33px' }}
                                />
                            </Box>
                            <Box sx={{ padding: '0 10px', minWidth: '150px' }}>
                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: 'bold' }}
                                >
                                    Date d&apos;effet :{' '}
                                    {new Date(
                                        gestionDirigeant.custom_l2d.dateEffetModificationDirigeant,
                                    ).toLocaleDateString('fr-FR') ?? ''}
                                </Typography>
                                <Typography variant="h6">
                                    {`${gestionDirigeant.individu?.descriptionPersonne?.prenoms ?? ''} ${gestionDirigeant.individu?.descriptionPersonne?.nom ?? ''}`}
                                    {gestionDirigeant.entreprise?.denomination ?? ''}
                                </Typography>
                                <Typography variant="h6">
                                    Situation du dirigeant:{' '}
                                    {gestionDirigeant.statutPourLaFormalite?.label ?? ''}
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            display="flex"
                            flexDirection="row"
                            gap="10px"
                            sx={{
                                margin: '0 0 0 auto',
                            }}
                        >
                            {actions
                                ? actions.map((action, key) => (
                                      <Box
                                          title={action.tooltip}
                                          data-testid={`test-id-${key}-handleClick-button`}
                                          onClick={() => action.onClick(gestionDirigeant, index)}
                                          role="button"
                                          key={action.name}
                                      >
                                          {action.icon || action.text}{' '}
                                      </Box>
                                  ))
                                : null}
                        </Box>
                    </Grid>
                </Grid>
            </Card>
        );
    };
